import { Modal } from "react-bootstrap";
import styles from "./Modal.module.scss";
import { useTranslation } from "react-i18next";
import ActionButton from "../Buttons/Action/ActionButton";

interface BadgeModalProps {
  show: boolean;
  newBadge: string;
  onDismiss: () => void;
}

const BadgeModal = ({ show, newBadge, onDismiss }: BadgeModalProps) => {
  const { t } = useTranslation();
  if (!show) return null;

  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      className={styles.modalWindow}
      show={show}
      centered
      onHide={onDismiss}
    >
      <Modal.Header className={styles.modalHeader}>
        <Modal.Title className={styles.modalTitle}>
          {t("game.newBadge")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={`${styles.badgeItem} ${styles.modalBody}`}>
        <div className={styles.badgeImageContainer}>
          <img
            src={`${process.env.REACT_APP_API_URL}/images/collectibles/badges/${newBadge}`}
            alt={newBadge}
            className="img-fluid"
          />
        </div>
      </Modal.Body>
      <Modal.Footer className={styles.modalBody}>
        <div className={styles.modalButtonContainer}>
          <ActionButton className={styles.modalButton} onClick={onDismiss}>
            {t("common.close")}
          </ActionButton>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default BadgeModal;
